
import O1HD from "../../../../../engines/gameEngine";
import data_control from "../../../../../engines/libs/data_control";
import utilsModel from "../../../../../engines/libs/utilsModel";
import utilsView from "../../../../../engines/libs/utilsView";
import PageBase from "../../../../../engines/modules/uiModule/PageBase";
import { KaoguArtcleSellPrams } from "../../../../../engines/modules/uiModule/UIPrams";
import { MessageEventKind } from "../../../../define/MessageEventKind";
import { BUNDLE_SMALL_NAME } from "../../../BundleResourceConfig";
import { backPackEventMap } from "../../../config/BackpackEventConfig";
import { getKaoguItemConfig } from "../kaogu/config/kaoguMountainConfig";

const { ccclass, property } = cc._decorator;

@ccclass
export default class kaoguArtcleSellPage extends PageBase {
    @property({ type: cc.Sprite, displayName: "图片" })
    img_oilfield: cc.Sprite = null;
    @property({ type: cc.Label, displayName: "名称" })
    lab_name: cc.Label = null;
    @property({ type: cc.Label, displayName: "价格" })
    lab_price: cc.Label = null;
    @property({ type: cc.Label, displayName: "内容" })
    lab_tips: cc.Label = null;
    @property({ type: cc.Node, displayName: "放入仓库" })
    btn_inCang: cc.Node = null;

    sellCall: (sPrice: number) => void = null;
    packageCall: () => void = null;
    protected useAnim : boolean = false;
    async OnPageOpen(prams?: KaoguArtcleSellPrams) {
        if (prams) {
            let data:any = getKaoguItemConfig[prams.id];
            if(!data&&prams.isArticle){
                let info = backPackEventMap()[prams.id];
                data = {
                    nickName:info.name,
                    sellPrice:info.sellPrice,
                    tips:info.details,
                    itemID:prams.id,
                    spriteimg:info.spPath
                }
            }
            this.lab_name.string = data.nickName;
            this.lab_price.string = `${data_control.getNumberFormat(data.sellPrice)}`;
            this.lab_tips.string = data.tips;

            this.btn_inCang.active = data.itemID != null;
            this.sellCall = prams.SellBack;
            this.packageCall = prams.PackageBack;
            this.loadImg(data.spriteimg)
        }
        
        super.OnPageOpen(prams)
    }

    async loadImg(url:string)
    {

        utilsView.loadItemImg('res/kaogu/kaoguitem/'+url, this.img_oilfield, null, BUNDLE_SMALL_NAME.kaogu);
        // (await LoadHelp.getBundleByName(BundleName.Touzi)).load('res/kaogu/kaoguitem/'+url,cc.Texture2D,(e,ass:cc.Texture2D)=>{
        //     if(e)
        //     {
        //         this.img_oilfield.spriteFrame=null;
        //         return
        //     }
        //     this.img_oilfield.spriteFrame=new cc.SpriteFrame(ass);

        // })
    }

    onClickSell() {
        this.sellCall && this.sellCall(1);
        this.OnCloseBtn();
    }
    onClickPackage() {
        this.packageCall && this.packageCall();
        this.OnCloseBtn();
    }

    onClickDoubleSell() {
        O1HD.getManagers().soundMgr.playSound('anNiu');
        cc.game.pause();
        utilsModel.loadAndShowVideoAdTrans(async () => {
            cc.game.resume();
            this.sellCall && this.sellCall(2);
            this.ClosePage();
        }, () => {
            cc.game.resume();
        }, null, '矿区双倍卖出');
    }
}